import { TableCell } from '~/UIKit';
import React from 'react';
import { DefaultCellProps } from './DefaultCell';
import { CellProps } from './CellProps';
import { makeStyles } from '~/UIKit/Style';

export interface TimeRangeCellProps {
  value: {
    start: string;
    end: string;
  };
}

const useStyles = makeStyles(() => ({
  time: {
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const TimeRangeCell = ({
  value,
  formatter = (val: any) => val,
  className,
}: TimeRangeCellProps & DefaultCellProps & CellProps) => {
  const { classes } = useStyles();
  return (
    <TableCell className={className}>
      <div className={classes.time}>
        <span>{formatter(value.start)}</span>
        <span>{formatter(value.end)}</span>
      </div>
    </TableCell>
  );
};

export default TimeRangeCell;
